module.exports = __webpack_public_path__ + "img/semitrailerFrontRight.9e40f9dc.svg";